"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatSignedDate = exports.dateOrdinal = void 0;
const dateOrdinal = (dayNumber) => {
    const asNumber = Number.parseInt(dayNumber, 10);
    if (isNaN(asNumber)) {
        throw new Error(`Could not parse ${dayNumber} into a Number`);
    }
    if (asNumber > 3 && asNumber < 21) {
        return 'th';
    }
    switch (asNumber % 10) {
        case 1:
            return 'st';
        case 2:
            return 'nd';
        case 3:
            return 'rd';
        default:
            return 'th';
    }
};
exports.dateOrdinal = dateOrdinal;
const formatSignedDate = (signed) => {
    try {
        // https://stackoverflow.com/a/3552493
        const parsed = Date.parse(signed);
        const dtf = new Intl.DateTimeFormat('en', { year: 'numeric', month: 'long', day: 'numeric' });
        const [{ value: mo }, , { value: da }, , { value: ye }] = dtf.formatToParts(parsed);
        return `${mo} ${da}${(0, exports.dateOrdinal)(da)} ${ye}`;
    }
    catch (error) {
        throw new Error(`Could not parse ${signed} into a Date`);
    }
};
exports.formatSignedDate = formatSignedDate;
//# sourceMappingURL=helpers.js.map